module.exports = __webpack_public_path__ + "1079a71955d6792994d8d3380eac4bb4.png";